import moment from 'moment';

import { API_DATE_FORMAT, DATE_DISPLAY_FORMAT } from '../../../../../../constants';

export const convertToClaimDateFormat = (dateString: string): string | null => {
  const parsed = moment(dateString, DATE_DISPLAY_FORMAT, true);
  return parsed.isValid() ? parsed.format(API_DATE_FORMAT) : null;
};
